import { setDeals, setLoading, setError, setFetchedAt } from './routines'

export default {
  [setDeals.TRIGGER](state, payload) {
    state.deals = Array.isArray(payload) ? payload : []
  },
  [setLoading.TRIGGER](state, payload) {
    state.isLoading = !!payload
  },
  [setError.TRIGGER](state, payload) {
    state.hasError = !!payload
  },
  [setFetchedAt.TRIGGER](state, payload) {
    state.lastFetchedAt = typeof payload === 'number' ? payload : Date.now()
  }
}
